import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=e5bfddee&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=js"
export * from "./CourseInfo.vue?vue&type=script&lang=js"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&id=e5bfddee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bfddee",
  null
  
)

export default component.exports